export default "__VITE_ASSET__90crUbKn__"